export enum Scheme {
    http,
    https
}

export interface Url {
    scheme: Scheme,
    hostname: string,
    port?: number
    path: string,
    query: string | { [key: string]: string }
    format(): string;
}

// regex to split urls into components
const urlregex = /^(http:\/\/|https:\/\/)([^:\/]+)(:[0-9]+){0,1}(\/[^?]*){0,1}(\?[^#]*){0,1}/;

export function parseUrl(url: string): Url {
    var matches = urlregex.exec(url);
    if (matches) {
        var schemestring = matches[1].substr(0, matches[1].length - 3) as string;
        var host = matches[2];
        var port = matches[3];
        return {
            scheme: (Scheme as any)[schemestring],
            hostname: matches[2],
            port: matches[3] ? parseInt(matches[3].substr(1)) : undefined,
            path: matches[4],
            query: matches[5] ? parseQuery(matches[5].substr(1)) : undefined,
            format: function () { return formatUrl(this); }
        };
    }
    return null;
}

export function parseQuery(query: string): { [key: string]: string } | undefined {
    if (!query)
        return undefined;

    return _.object(_.map(query.split('&'), exp => {
        return _.map(exp.split(/=(.+)?/, 2), (v, i) => i === 0 ? v : decodeURIComponent(v))
    })) as { [key: string]: string };
}

function formatUrl(url: Url): string {
    var querystring = '';
    if (url.query) {
        querystring = `?${_.isString(url.query) ? url.query : _.map(url.query as { [key: string]: string }, (val, name) => {
            return `${name}=${encodeURIComponent(val)}`;
        }).join('&')}`;
    }
    var schemestring = _.isString(url.scheme) ? url.scheme : Scheme[url.scheme];
    return `${schemestring}://${url.hostname}${_.isUndefined(url.port) ? '' : ':' + url.port}${url.path || ''}${querystring}`;
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/Url.ts